// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"U4-z"};